import { combineReducers } from '@reduxjs/toolkit';

import { connectionsApi } from '~direct-debits/actions/connections';

// No slice reducers in this feature yet — placeholder keeps combineReducers valid
const placeholder = (state = {}) => state;
export default combineReducers({ placeholder });

export const directDebitsApis = [connectionsApi] as const;
